import { createBrowserHistory } from 'history';

export const goBack = () => history.back();

export default createBrowserHistory();
